<script setup lang="ts">
import CompetitionPath from './CompetitionPath.vue'
import Logo from './Logo/Logo.vue'
import ParticipantsName from './ParticipantsName.vue'

defineProps<{
  areaName?: string
  shortName?: string
  stageName?: string
  homeName: string
  awayName: string
}>()
</script>

<template>
  <Logo class="h-6" />
  <div class="flex flex-col overflow-hidden px-2">
    <CompetitionPath
      :areaName
      :shortName
      :stageName
    />
    <ParticipantsName
      :homeName
      :awayName
    />
  </div>
</template>
